<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>

        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">


            <card-header title="Edit Site">
              <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
              <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Save</base-button>
            </card-header>

            <b-card-body>
              <b-row>
                <b-col md="6">
                  <base-input label="Name" name="name" v-model="form.name" :rules="{required: true, apiname: true}" />
                </b-col>
                <b-col md="6">
                  <base-input label="Description" name="description" v-model="form.description"/>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Alloc Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.allocinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.allocinfo" />
                  </fieldset>
                </b-col>

                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Global Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.globalinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.globalinfo" />

                  </fieldset>
                </b-col>
                <b-col md="6">
                  <fieldset class="form-group">
                    <label class="form-control-label">Unalloc Info <span class="font-weight-light">Optional</span></label>

                    <base-input :rules="{json: true}">
                      <textarea class="form-control font-mono" rows="6" v-model="form.unallocinfo" />
                    </base-input>

                    <file-loader
                        initialLabel="Load JSON file"
                        accept=".json"
                        :maxSize="100000"
                        :parse-json="false"
                        :content.sync="form.unallocinfo" />

                  </fieldset>
                </b-col>

              </b-row>

              <b-row>
                <b-col md="3">
                  <base-input label="Address" name="street" placeholder="Street" v-model="form.address.street" />
                </b-col>
                <b-col md="3" class="no-label">
                  <base-input name="number" placeholder="Number" v-model="form.address.number" :rules="{ numeric: true }"/>
                </b-col>

                <b-col md="3">
                  <base-input label="GPS" name="latitude" placeholder="Latitude" v-model="form.latitude" :rules="{ latitude: true, required: true }" />
                </b-col>
                <b-col md="3" class="no-label">
                  <base-input label="" name="longitude" placeholder="Longitude" v-model="form.longitude" :rules="{ longitude: true, required: true }" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <base-input name="postalcode" placeholder="Postalcode" v-model="form.address.postalcode" />
                </b-col>
                <b-col md="3">
                  <base-input name="locality" placeholder="Locality/town" v-model="form.address.city" />
                </b-col>
              </b-row>

              <b-row>
                <b-col md="3">
                  <base-input name="region" placeholder="Region" v-model="form.address.region" />
                </b-col>
                <b-col md="3">
                  <base-input name="country" placeholder="Country" v-model="form.address.country" />
                </b-col>
              </b-row>

            </b-card-body>


          </b-form>
        </validation-observer>
    <b-card-body>
          <b-row>
            <b-col>
              <base-button 
                type="primary" 
                size="sm" 
                @click="showResourcesModal"
              >
                <i class="fas fa-folder-open mr-1"></i> Manage Resources
              </base-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-container>

<upload-modals
  ref="uploadModals"
  title="Entity"
  :id="form.name"
  :site-id="form.site"
  :existing-files="existingFiles"
  :existing-firmware="existingFirmware"
  :existing-icons="existingIcons"                     
  @upload-file="uploadFile"
  @upload-firmware="uploadFirmware"
  @upload-icon="onUploadIcon"                         
  @delete-file="confirmDeleteFile"
  @delete-firmware="confirmDeleteFirmware"
  @delete-icon="confirmDeleteIcon"                   
  @fetch-files="fetchSiteFiles"
  @fetch-firmware="fetchSiteFirmware"
  @fetch-icons="fetchSiteIcons"                    
  @firmware-tab-activated="syncGitlab"
/>


  
  </div>
</template>



<script>
import {Routes} from "@/router";
import CardHeader from "@/views/components/CardHeader";
import {Action} from "@/store/actions";
import {mapGetters} from "vuex";
import {MapServiceSite} from "@/services/map.service";
import FileLoader from "@/views/components/FileLoader";
import UploadModals from "@/views/components/UploadModals";

export default {
  name: "SiteNew",
  components: {
    CardHeader,
    FileLoader,
    UploadModals
  },
  // ---------------------
  data() {
    return {
       syncingGitlab: false, 
      form: {
        name: '',
        description: '',
        networkinfo: undefined,
        globalinfo: undefined,
        allocinfo: undefined,
        unallocinfo: undefined,
        devicePath: "",
        uploading: false,
        address: {
          street: '',
          number: undefined,
          postalcode: '',
          city: '',
          region: '',
          country: '',
        },
        latitude: '',
        longitude: '',
      },
      fileToUpload: null,
      accept: '*/*', // Accept all file types
      maxSize: 10000000, // 10MB max size
  
      activeSite: null,
      //showFileModal: false,
      existingFiles: [],
      fileFields: [
        { key: 'filename', label: 'File Name' },
        { key: 'file_device_path', label: 'Device Path' },
        { key: 'upload_date', label: 'Upload Date' },
        { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
        { key: 'actions', label: 'Actions' }
      ],
      activeTab: 0,
      //showFirmwareModal: false,
      existingFirmware: [],
      firmwareFields: [
        { key: 'version', label: 'Version' },
        { key: 'device_type', label: 'Device Type' },
        { key: 'filename', label: 'File Name' },
        { key: 'release_date', label: 'Upload Date' },
        { key: 'actions', label: 'Actions' }
      ],
      firmwareFile: null,
      firmwareVersion: '',
      firmwareDescription: '',
      firmwareUploading: false,
      activeFirmwareTab: 0,
      isLoading: false,
      deviceTypeOptions: [
      { value: 'CC1', text: 'CC1' },
      { value: 'CC2', text: 'CC2' }
    ],
    existingIcons: [],
iconFields: [
  { key: 'filename', label: 'Original Name' },
  { key: 'converted_filename', label: 'Converted Name' },
  { key: 'format', label: 'Format' },
  { key: 'file_device_path', label: 'Device Path' },
  { key: 'upload_date', label: 'Upload Date' },
  { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
  { key: 'actions', label: 'Actions' }
],
      firmwareDeviceType: 'CC2'

    };
  },
  // ---------------------

  computed: {
    ...mapGetters(['siteByName']),
     canUploadFirmware() {
      return this.firmwareFile && 
             this.firmwareVersion && 
             this.firmwareDeviceType
    }
  },
  // ---------------------
  methods: {
     showFileModal() {
      this.$refs.uploadModals.showFilesModal();
    },
    async syncGitlab() {
  // Entity name is the form's name (e.g., "Infrafon_dev")
    const site = this.siteByName(this.activeSite);
    const entity = site?.entity;
  if (!entity) {
    this.$notify({ type: 'danger', title: 'Error', text: 'Entity name missing.' });
    return;
  }

  this.syncingGitlab = true;
  try {
    const resp = await this.$http.post(
      `/tenant/${entity}/firmware/sync-gitlab?device_type=CC2`
    );
   
    await this.fetchEntityFirmware();   // refresh the list
  } catch (e) {
    let msg = 'Unexpected error';
    if (e.response) {
      const data = e.response.data || {};
      msg = data.error || data.message || `Server error ${e.response.status}`;
    } else if (e.request) {
      msg = 'No response from server – check network.';
    } else {
      msg = e.message;
    }
  } finally {
    this.syncingGitlab = false;
  }
},
        showResourcesModal() {
      this.$refs.uploadModals.openModal(0); // open Files tab by default
    },

    
    showFirmwareModal() {
      this.$refs.uploadModals.showFirmwaresModal();
    },
    resetFileUpload() {
    this.activeTab = 0;
    this.fileToUpload = null;
    this.devicePath = "";
    this.uploading = false;
    },
  
    resetFirmwareUpload() {
    this.activeFirmwareTab = 0;
    this.resetFirmwareForm();
    this.firmwareUploading = false;
    },
    onCancel() {
      this.$router.push({name: Routes.siteList});
    },
    onSubmit() {
      this.isLoading = true
      const model = MapServiceSite.formToModel(this.form)
      this.$store.dispatch(Action.site.save, {name: this.activeSite, data: model})
        .then(() => {
          this.$router.push({name: Routes.siteList})
        }).catch(error => {
          this.isLoading = false
          console.error(error)
        })
    },
    onFileLoaded(fileContent, fileName) {
      this.fileToUpload = {
        content: fileContent,
        name: fileName
      };
    },
    
    // In your Vue component
    async uploadFile(fileData, callback) {
 
    try {
        const formData = new FormData();
        const blob = new Blob([fileData.content]);
        
        // Log file details before upload
      /*  console.log("Uploading file:", {
          fileName: fileData.name,
          fileSize: blob.size,
          site: this.form.name,
          devicePath: fileData.devicePath
        });*/
        formData.append('file', new Blob([fileData.content]), fileData.name);
        formData.append('site_id', fileData.id);
        formData.append('level', 'site');
          if (fileData.devicePath) {
          formData.append('file_device_path', fileData.devicePath);
        }

        // Use the store action instead of direct API call
        await this.$store.dispatch(Action.site.uploadSiteFile, formData);
        
        this.$notify({
            type: 'success',
            title: 'File Upload',
            text: 'File uploaded successfully!'
        });
         callback();
      this.fetchSiteFiles(); // Refresh the list
        
    } catch (error) {
        this.$notify({
            type: 'danger',
            title: 'File Upload Failed',
            text: error.response?.data?.message || 'Failed to upload file'
        });
         callback();
    }
    },
 async onUploadIcon(iconData, callback) {
 //   console.log('[SiteEdit] onUploadIcon CALLED', iconData);
    try {
        const formData = new FormData();
        formData.append('file', new Blob([iconData.content]), iconData.name);
        formData.append('site_id', iconData.id);               // use site_id
        formData.append('level', 'site');                      // set level
        if (iconData.devicePath) {
            formData.append('file_device_path', iconData.devicePath);
        }
        if (iconData.description) {
            formData.append('description', iconData.description);
        }
        await this.$store.dispatch(Action.site.uploadSiteIcon, formData);
        this.$notify({ type: 'success', title: 'Icon Upload', text: 'Icon uploaded successfully!' });
        callback();
        this.fetchSiteIcons();
    } catch (error) {
        this.$notify({ type: 'danger', title: 'Icon Upload Failed', text: error.response?.data?.message || 'Failed to upload icon' });
        callback();
    }
},

async fetchSiteIcons() {
    try {
        const response = await this.$store.dispatch(Action.site.listSiteIcons, this.form.name);
        this.existingIcons = response?.icons || [];
    } catch (error) {
        console.error("Failed to fetch site icons", error);
    }
},

confirmDeleteIcon(icon) {
    this.$bvModal.msgBoxConfirm(`Delete ${icon.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
    }).then(confirmed => {
        if (confirmed) this.deleteIcon(icon);
    });
},

async deleteIcon(icon) {
    try {
        await this.$store.dispatch(Action.site.deleteSiteIcon, icon.id);
        this.$notify({ type: 'success', title: 'Icon Deleted', text: `${icon.filename} was removed` });
        await this.fetchSiteIcons();
    } catch (error) {
        console.error("Failed to delete icon", error);
        this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete icon' });
    }
},

confirmDeleteAllIcons() {
    this.$bvModal.msgBoxConfirm(`Delete all ${this.existingIcons.length} icons? This cannot be undone.`, {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
    }).then(confirmed => {
        if (confirmed) this.deleteAllIcons();
    });
},

async deleteAllIcons() {
    try {
        await this.$store.dispatch(Action.site.deleteAllSiteIcons, this.form.name);
        this.$notify({ type: 'success', title: 'Icons Deleted', text: `All icons removed` });
        this.existingIcons = [];
    } catch (error) {
        console.error("Failed to delete all icons", error);
        this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete all icons' });
    }
},

async fetchEntityIcons() {
  try {
    const response = await this.$store.dispatch(Action.entity.listEntityIcons, this.form.name);
    this.existingIcons = response?.icons || [];
  } catch (error) {
    console.error("Failed to fetch entity icons", error);
  }
},

confirmDeleteIcon(icon) {
  this.$bvModal.msgBoxConfirm(`Delete ${icon.filename}? This cannot be undone.`, {
    title: 'Confirm Delete',
    okVariant: 'danger',
    okTitle: 'Delete',
    cancelTitle: 'Cancel',
    centered: true
  }).then(confirmed => {
    if (confirmed) this.deleteIcon(icon);
  });
},

async deleteIcon(icon) {
  try {
    await this.$store.dispatch(Action.entity.deleteEntityIcon, icon.id);
    this.$notify({ type: 'success', title: 'Icon Deleted', text: `${icon.filename} was removed` });
    await this.fetchEntityIcons();
  } catch (error) {
    console.error("Failed to delete icon", error);
    this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete icon' });
  }
},

confirmDeleteAllIcons() {
  this.$bvModal.msgBoxConfirm(`Delete all ${this.existingIcons.length} icons? This cannot be undone.`, {
    title: 'Confirm Delete All',
    okVariant: 'danger',
    okTitle: 'Delete All',
    cancelTitle: 'Cancel',
    centered: true
  }).then(confirmed => {
    if (confirmed) this.deleteAllIcons();
  });
},

async deleteAllIcons() {
  try {
    await this.$store.dispatch(Action.entity.deleteAllEntityIcons, this.form.name);
    this.$notify({ type: 'success', title: 'Icons Deleted', text: `All icons removed` });
    this.existingIcons = [];
  } catch (error) {
    console.error("Failed to delete all icons", error);
    this.$notify({ type: 'danger', title: 'Delete Failed', text: 'Failed to delete all icons' });
  }
},
    async fetchSiteFiles() {
  try {
    const response = await this.$store.dispatch(
      Action.site.listSiteFiles, 
      this.form.name
    );
    this.existingFiles = response.files || [];
  } catch (error) {
    console.error("Failed to fetch site files", error);
  }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    confirmDeleteFile(file) {
      this.$bvModal.msgBoxConfirm(`Delete ${file.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFile(file);
        }
      });
    },
    async deleteFile(file) {
  try {
    await this.$store.dispatch(
      Action.site.deleteSiteFile, 
      file.id
    );
     this.$notify({
          type: 'success',
          title: 'File Deleted',
          text: `${file.filename} was successfully removed`
        });
    await this.fetchSiteFiles(); // Refresh list
  } catch (error) {
    console.error("Failed to delete file", error);
  }
    },
    confirmDeleteAllFiles() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFiles.length} files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFiles();
      }
    });
      },
  
    async deleteAllFiles() {
    try {
      await this.$store.dispatch(
        Action.site.deleteAllSiteFiles, 
        this.form.name
      );
      
      this.$notify({
        type: 'success',
        title: 'Files Deleted',
        text: `All ${this.existingFiles.length} files were successfully removed`
      });
      
      this.existingFiles = [];
    } catch (error) {
      console.error("Failed to delete all files", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all files'
      });
    }
    },
  
 
    onFirmwareFileLoaded(fileContent, fileName) {
      this.firmwareFile = {
        content: fileContent,
        name: fileName
      }
    },
    
    async uploadFirmware(firmwareData, callback) {
      // Debug: Starting the upload process
     

      try {
        // Debug: Show formData contents
        const formData = new FormData();
        formData.append('firmware_file', new Blob([firmwareData.content]), firmwareData.name);
        formData.append('version', firmwareData.version);
        formData.append('device_type', firmwareData.deviceType);
        formData.append('description', firmwareData.description || '');
        formData.append('level', 'site');
        formData.append('site_id',  firmwareData.id);
           if (firmwareData.wifiContent) {
      formData.append('wifi_firmware_file', new Blob([firmwareData.wifiContent]), firmwareData.wifiName);
    }

        // Log FormData contents (requires special handling)
        console.debug("[DEBUG] FormData contents:");
        for (const [key, value] of formData.entries()) {
          if (key === 'firmware_file') {
            console.debug(`  ${key}:`, `File(${value.name}, ${value.size} bytes)`);
          } else {
            console.debug(`  ${key}:`, value);
          }
        }

        // Debug: Before dispatching Vuex action
   

        // Dispatch the action
        const result = await this.$store.dispatch(
          Action.site.uploadSiteFirmware, 
          formData
        );

        // Debug: After successful upload
        this.showNotification('Firmware uploaded successfully!', 'success');
        this.resetFirmwareForm();
        this.$nextTick(this.resetFirmwareUpload);
        callback();
      } catch (error) {
        // Enhanced error logging
        console.error("[ERROR] Firmware upload failed:", error);
        
        // Detailed API error response
        if (error.response) {
          console.error("[DEBUG] API Error Response:", {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers
          });
        } else if (error.request) {
          console.error("[DEBUG] No response received:", error.request);
        } else {
          console.error("[DEBUG] Request setup error:", error.message);
        }
        
        // User notification
        const errorMessage = error.response?.data?.message || 
                             error.message || 
                             'Unknown firmware upload error';
        this.showNotification(`Firmware upload failed: ${errorMessage}`, 'danger');
      } finally {
        console.debug("[DEBUG] Upload process completed");
        this.firmwareUploading = false;
      }
    },
    async fetchSiteFirmware() {
  try {
    const response = await this.$store.dispatch(
      Action.site.listSiteFirmware, 
      this.form.name
    );
    // Remove .firmwares since the response is the array directly
    this.existingFirmware = response || [];
  } catch (error) {
    console.error("Failed to fetch site firmware", error);
  }
    },
    
    confirmDeleteFirmware(firmware) {
      this.$bvModal.msgBoxConfirm(`Delete ${firmware.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFirmware(firmware);
        }
      });
    },
    
    async deleteFirmware(firmware) {
      try {
        const originalList = [...this.existingFirmware];
    
    // Optimistically remove the firmware from the list
    this.existingFirmware = this.existingFirmware.filter(fw => fw.id !== firmware.id);
        await this.$store.dispatch(
          Action.site.deleteSiteFirmware, 
          firmware.id 
        );
          this.showNotification(
          `Firmware ${firmware.filename} (v${firmware.version}) deleted successfully!`,
          'success'
        );
        await this.fetchSiteFirmware();
      } catch (error) {
            this.existingFirmware = originalList;

         this.showNotification(
          'Firmware deletion failed', 
          'danger', 
          error
        );
        console.error("Failed to delete firmware", error);
      }
    },
    confirmDeleteAllFirmware() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFirmware.length} firmware files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFirmware();
      }
    });
    },
  
    async deleteAllFirmware() {
    try {
      await this.$store.dispatch(
        Action.site.deleteAllSiteFirmware, 
        {
          siteId: this.form.name,
          deviceType: 'CC2' // Default device type
        }
      );
      
      this.$notify({
        type: 'success',
        title: 'Firmware Deleted',
        text: `All ${this.existingFirmware.length} firmware files were successfully removed`
      });
      
      this.existingFirmware = [];
    } catch (error) {
      console.error("Failed to delete all firmware", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all firmware'
      });
    }
    },
    
    resetFirmwareForm() {
      this.firmwareData = null;
      this.firmwareVersion = '';
      this.firmwareDeviceType = '';
      this.firmwareDescription = '';
    },
    
    showNotification(message, type, error = null) {
      const text = error
        ? error.response?.data?.message || 'An unexpected error occurred'
        : message;
      
      this.$notify({
        type,
        title: type === 'success' ? 'Success' : 'Error',
        text
      });
    }
  },
  // ---------------------
  mounted() {
    const name = this.$route.params.name
    if(!name) { this.$router.back() }
    const site = this.siteByName(name)
    if(!site) { this.$router.back() }
    this.activeSite = name;
    this.form = MapServiceSite.modelToForm(site, this.form)
  },
}
</script>

